"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keys = void 0;
/**
 * A typed version of Object.keys, to use when looping over a static object
 * inspired from https://stackoverflow.com/a/65117465/3185307
 */
var keys = exports.keys = Object.keys;